import {
	useConsultaMedicamentos,
	ConsultaMedicamentosProvider,
} from './ConsultaMedicamentosContext';
import LoadingView from './views/LoadingView';
import ConsultaMedicamentosForm from './views/FormView';
import ConfirmationView from './views/ConfirmationView';
import {
	FormResponseModal,
	InfoRecetaModal,
	MiRecetaModal,
	ReservaExistenteModal,
	ReservarMedicamentoModal,
} from './views/Modals';
import ResultsView from './views/ResultsView';
import { useLayoutEffect } from 'react';

function Content() {
	const { view } = useConsultaMedicamentos();

	useLayoutEffect(() => {
		document.documentElement.scrollTo(0, 0);
	}, [view]);

	switch (view) {
		case 'form':
			return <ConsultaMedicamentosForm />;
		case 'loading':
			return <LoadingView />;
		case 'response':
			return <ResultsView />;
		case 'confirmation':
			return <ConfirmationView />;
		default:
			return null;
	}
}

export default function ConsultaMedicamentos() {
	return (
		<ConsultaMedicamentosProvider>
			<Content />
			<MiRecetaModal />
			<InfoRecetaModal />
			<FormResponseModal />
			<ReservaExistenteModal />
			<ReservarMedicamentoModal />
		</ConsultaMedicamentosProvider>
	);
}
